import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SiInlineNotificationComponent } from '@siemens/element-ng/inline-notification';
import { NotificationService } from '../../../services/notification.service';

@Component({
    selector: 'tran-notification-outlet',
    imports: [SiInlineNotificationComponent],
    templateUrl: './notification-outlet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationOutletComponent {
    protected readonly notificationService = inject(NotificationService);
}
